<template>
	<div class="incenters">
		<div style="">
			<!--v-if="qx.add"   -->
			<!-- <Commonbtn backgroundColor="#FFF" title="新增" fontSize="14px" @btnclick="invAdd"
				:src="require('@/assets/icon/icon-add.png')">
			</Commonbtn> -->
			<el-dropdown style="margin-right:12px;" @command="handleDrop">
				<div class="drop-down-link">
					新增<i class="el-icon-arrow-down el-icon--right"></i>
				</div>
				<el-dropdown-menu slot="dropdown">
					<el-dropdown-item command="a">蓝字发票</el-dropdown-item>
					<el-dropdown-item command="b">红冲发票</el-dropdown-item>
				</el-dropdown-menu>
			</el-dropdown>
			<!--  :optional="editops"  -->
			<Commonbtn v-if="qx.update" backgroundColor="#FFF" opwidth="72px" top="420px" title="修改" fontSize="14px"
				:optional="sbmidarr.length !== 1" :useAutoOptional="false" @btnclick="update" :src="require('@/assets/icon/icon-update.png')">
			</Commonbtn>
			<Commonbtn v-if="qx.enabled" backgroundColor="#FFF" title="审核" fontSize="14px" @btnclick="shen"
				:src="require('@/assets/icon/shen.png')">
			</Commonbtn>
			<Commonbtn v-if="qx.revoke" backgroundColor="#FFF" title="弃审" fontSize="14px" @btnclick="qshen"
				:src="require('@/assets/icon/shua.png')">
			</Commonbtn>
			<Commonbtn backgroundColor="#FFF" v-if="qx.del" title="删除" fontSize="14px" @btnclick="del"
				:src="require('@/assets/icon/icon-del.png')">
			</Commonbtn>
			<Commonbtn backgroundColor="#FFF" title="导出" fontSize="14px" @btnclick="SaleBillExport"
				:src="require('@/assets/icon/daoc.png')">
			</Commonbtn>
			<CommonbtnUpLoad v-if="qx.add" backgroundColor="#FFF" types="multiple" title="上传发票图片" fontSize="14px"
				@getFiles="UploadPhotos" :src="require('@/assets/icon/daoc.png')">
			</CommonbtnUpLoad>
			<CommonbtnUpLoad backgroundColor="#FFF" v-if="qx.add" types="multiple" title="上传销货清单照片" fontSize="14px"
				@getFiles="UploadSaleslist" :src="require('@/assets/icon/daoc.png')">
			</CommonbtnUpLoad>
			<CommonbtnUpLoad backgroundColor="#FFF" v-if="qx.add" title="发票导入" fontSize="14px" @getFile="InvoiceImport"
				:src="require('@/assets/icon/daoc.png')">
			</CommonbtnUpLoad>
			<!--  v-if="qx.setting" -->
			<CommonbtnUpLoad v-if="CusTypeFlog == 0" backgroundColor="#FFF" types="file" title="打包下载发票照片"
				fontSize="14px" @getFile="DownloadInvoicePic" :src="require('@/assets/icon/daoc.png')">
			</CommonbtnUpLoad>
			<!-- v-if="qx.setting" -->
			<Commonbtn v-if="CusTypeFlog == 0" backgroundColor="#FFF" title="发票照片标注" fontSize="14px"
				@btnclick="invoicephoto" :src="require('@/assets/icon/phont.png')">
			</Commonbtn>
			<Commonbtn backgroundColor="#FFF" title="指导视频" fontSize="14px" @btnclick="GuidanceVideo"
				:src="require('@/assets/icon/video.png')">
			</Commonbtn>
			<!-- v-if="qx.changeth" -->
			<Commonbtn v-if="qx.changeth" backgroundColor="#FFF" title="变更终端医院" fontSize="14px"
				@btnclick="TerminalHospital" :src="require('@/assets/icon/hospital-two.png')">
			</Commonbtn>
			<Commondown types=3 titles="颜色说明" backgroundColor="#FFF" color="#E71D43" fontSize="14px"
				:datalist="downlist" @downs="downs"></Commondown>
			<a v-if="qx.add"
				style="display: inline-block;font-size: 12px;margin-left: 10px;color: #00266D;text-decoration: underline;cursor: pointer;"
				@click="InvoiceDowload">下载销售发票导入模版</a>
		</div>
		<div class="TableWidth">
			<Commontable ref="refTableCenter" @handleSelectionChange="handleSelectionChange" @onRowClick="onRowClick"
				colnum=511 :tableData="tableData" :headerData="headerDataTow" height="100%">
			</Commontable>
			<div class="pagination">
				<Pagination ref="invPagination" @handleCurrentChange="handleCurrentChange"
					@handleSizeChange="handleSizeChange" :total="total"></Pagination>
			</div>
		</div>
		<!-- <div class="TableWidth" v-else>
			<Commontable ref="refTableCenter" @handleSelectionChange="handleSelectionChange" @onRowClick="onRowClick"
				colnum=511 :tableData="tableData" :headerData="headerData" height="100%">
			</Commontable>
			<div class="pagination">
				<Pagination @handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange"
					:total="total"></Pagination>
			</div>
		</div> -->
		<DialogFrom width="648px" title="发票照片标注" :dialogVisible="dialogVisiblesinvoicephoto"
			@cancel="cancelinvoicephoto" @dialogOK="dialogOKinvoicephoto">
			<div style="margin-left: -10px;margin-top: -10px;">
				<CommonbtnUpLoad backgroundColor="#FFF" types="multiple" title="上传标注图片" fontSize="14px"
					@getFiles="UploadSalesphoto" :src="require('@/assets/icon/daoc.png')">
				</CommonbtnUpLoad>
			</div>
			<div style="display: inline-block;">
				<el-select v-model="InvoiceValue" clearable placeholder="请选择" class="elselect">
					<el-option v-for="item in options11" :key="item.label" :label="item.label" :value="item.value">
					</el-option>
				</el-select>
			</div>
			<!-- <div style="display: inline-block;" v-if="InvoiceCheckeds == 1">
        <el-select v-model="InvoiceValue" clearable placeholder="请选择" class="elselect">
          <el-option v-for="item in options1" :key="item.label" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </div>
      <div style="display: inline-block;" v-if="InvoiceCheckeds == 0">
        <el-select v-model="InvoiceValue" clearable placeholder="请选择" class="elselect">
          <el-option v-for="item in options2" :key="item.label" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </div> -->

			<div style="color: #333333;font-size: 14px;">
				请填写发票照片校验状态标注：
			</div>
			<textarea style="border: 1px solid #E6E6E6;width: 608px;height: 180px;margin-top: 10px;"
				v-model="InvoiceRemark"></textarea>
		</DialogFrom>
		<Dialog width="420px" title="提示信息" :dialogVisible="dialogVisibleqshen" @cancel="cancelqshen"
			@dialogOK="dialogOKqshen" :src="require('@/assets/icon/icon-errors.png')">
			<span
				style="display: inline-block;position: absolute; top: 50px; left: 50px; font-size: 14px;color: #666666;">确认要弃审通过这条发票信息吗？</span>
		</Dialog>
		<Dialog width="420px" title="提示信息" :dialogVisible="dialogVisibleqdel" @cancel="canceldel"
			@dialogOK="dialogOKdel" :src="require('@/assets/icon/icon-del2.png')">
			<span
				style="display: inline-block;position: absolute; top: 50px; left: 50px; font-size: 14px;color: #666666;">确认要删除这条发票信息吗？</span>
		</Dialog>
		<Dialog width="420px" title="提示信息" :dialogVisible="dialogVisibleshen" @cancel="cancelshen"
			@dialogOK="dialogOKshen" :src="require('@/assets/icon/icon-errors.png')">
			<span
				style="display: inline-block;position: absolute; top: 50px; left: 50px; font-size: 14px;color: #666666;">确认要审核这条发票信息吗？</span>
		</Dialog>
		<DialogFrom width="890px" title="发票上报管理指导视频" :OKASCAN="false" :dialogVisible="dialogVisibGuidanceVideo"
			@cancel="cancelGuidanceVideo" @dialogOK="dialogOKGuidanceVideo">
			<VideoPlayer ref="invoicesVideo" :srcVideo="require('../../../../assets/video/invoices/invoices.mp4')">
			</VideoPlayer>
		</DialogFrom>
		<DialogFrom width="890px" title="变更终端医院" :dialogVisible="dialogVisibTerminalHospital"
			@cancel="cancelTerminalHospital" @dialogOK="dialogOKTerminalHospital">
			<div v-for="(item, index) of invTerminalHospitalfromdata" style="display: inline-block" :key="index">
				<Commondropdownlist ref="outTerminalHospital" :widths="item.widths" :inputflag="item.inputflag"
					:disabledHB="item.disabled" :loading="loading" :event="item.event"
					@remoteMethodtowHB="remoteMethodtowHBTerminalHospital" :btx="item.btx" :key="index"
					:options="item.options" :minrigth="item.minrigth" :maxrigth="item.maxrigth" :minleft="item.minleft"
					:maxleft="item.maxleft" :lablewith="item.lablewith" :inputdata="item.inputdata" :title="item.title"
					:fontSize="item.fontSize" :color="item.color" :placeholder="item.placeholder" :types="item.types"
					:inputtype="item.inputtype" :width="item.width"></Commondropdownlist>
			</div>
		</DialogFrom>
		<DialogFrom width="1030px" title="选择出库单" :OKASCAN="false" :dialogVisible="dialogVisibleoutboundorder"
			@cancel="canceloutboundorder" @dialogOK="dialogOKcanceloutboundorder">
			<div style="height: 700px; overflow-y: scroll;overflow-x: hidden;">
				<div :class="showorhide ? 'inputtop' : 'inputtops'">
					<div style="display: inline-block;" v-for="(item, index) of outformdata" :key="index">
						<Commondropdownlist ref="OutselectRef" :inputflag="item.inputflag" :options="item.options"
							:minrigth="item.minrigth" :maxrigth="item.maxrigth" :minleft="item.minleft"
							:maxleft="item.maxleft" :lablewith="item.lablewith" :inputdata="item.inputdata"
							:title="item.title" :fontSize="item.fontSize" :color="item.color"
							:placeholder="item.placeholder" :types="item.types" :inputtype="item.inputtype"
							:width="item.width"></Commondropdownlist>
					</div>
					<div :class="showorhide ? 'Btngroups' : 'Btngroup'">
						<CommonBtngroup ref="btngroup" :show="showorhide" @showclick="showclick" @hide="hide"
							@select="Outselect" @reset="Outreset"></CommonBtngroup>
					</div>
					<div style="height:10px;">
					</div>
				</div>
				<Commonbtn backgroundColor="#FFF" title="选择" fontSize="14px" @btnclick="invSel"
					:src="require('@/assets/icon/shen.png')">
				</Commonbtn>
				<div style="width: 970px;margin-top: 10px;overflow: scroll;">
					<Commontable ref="Table511" :loadingTable="OutAddLoading"
						@handleSelectionChange="handleSelectionChangeAdd" @onRowClick="onRowClickAdd"
						:selectabletype="1" width="940px" colnum=511 :tableData="tableDataDespatch"
						:headerData="headerDataDespatch" height="100%"></Commontable>
				</div>
				<div class="pagination">
					<Pagination @handleCurrentChange="handleCurrentChanges" @handleSizeChange="handleSizeChanges"
						:total="totals"></Pagination>
				</div>
				<div style="width: 970px;">
					<div>
						<div class="topstate" v-for="(item, index) of state" :key="index"
							:class="[{ 'ativte': onchage == index }]" @click="tabClick(index)">
							{{ item.title }}
						</div>
					</div>
					<div v-if="tableflag" style="overflow-x: scroll;overflow-y: scroll;max-height: 200px;">
						<Commontable :rowhe="false" width="940px" colnum=7 :loadingTable="loadingTable"
							:tableData="tableDataDetail" :headerData="headerDataDetail" height="100%"></Commontable>
					</div>
					<div v-if="tableflags" width="1000px"
						style="overflow-x: scroll;overflow-y: scroll;max-height: 200px;">
						<Commontable :rowhe="false" width="940px" colnum=7 :loadingTable="loadingTable"
							:tableData="tableDataDetailUnique" :headerData="headerDataUnique" height="100%">
						</Commontable>
					</div>
				</div>
			</div>
		</DialogFrom>



		<DialogFrom width="1000px" title="选择发票" :OKASCAN="false" :dialogVisible="dialogVisibleoutboundorder2"
			@cancel="dialogVisibleoutboundorder2 = false">
			<div style="height: 700px; overflow-y: scroll;overflow-x: hidden;">
				<div style="padding-top:0px;height:195px;" :class="showorhide ? 'inputtop' : 'inputtops'">
					<div style="display: inline-block;" v-for="(item, index) of selectformdata" :key="index">
						<Commondropdownlist ref="invselect" v-if="!item.hidden" :inputflag="item.inputflag"
							:options="item.options" :minrigth="item.minrigth" :maxrigth="item.maxrigth"
							:minleft="item.minleft" :maxleft="item.maxleft" :lablewith="item.lablewith"
							:inputdata="item.inputdata" :title="item.title" :fontSize="item.fontSize"
							:color="item.color" :placeholder="item.placeholder" :types="item.types"
							:inputtype="item.inputtype" :width="item.width"></Commondropdownlist>
					</div>
					<div :class="showorhide ? 'Btngroups' : 'Btngroup'">
						<CommonBtngroup ref="btngroup" :qhide="false" :show="showorhide" @select="handSelect"
							@reset="handReset"></CommonBtngroup>
					</div>
					<div style="height:10px;">
					</div>
				</div>
				<Commonbtn backgroundColor="#FFF" title="红冲" fontSize="14px" @btnclick="invSel2(11)"
					:src="require('@/assets/icon/shen.png')">
				</Commonbtn>
				<Commonbtn backgroundColor="#FFF" title="折让" fontSize="14px" @btnclick="invSel2(12)"
					:src="require('@/assets/icon/hospital-two.png')">
				</Commonbtn>
				<Commonbtn backgroundColor="#FFF" title="作废" fontSize="14px" @btnclick="invSel2(13)"
					:src="require('@/assets/icon/icon-del.png')">
				</Commonbtn>
				<div style="width: 970px;margin-top: 10px;overflow: scroll;">
					<Commontable ref="Table512" :loadingTable="OutAddLoading"
						@handleSelectionChange="handleSelectionChangeAdd" @onRowClick="onRowClickSel"
						:selectabletype="1" width="940px" colnum=511 :tableData="tableDataDespatch2"
						:headerData="headerDataTow" height="100%"></Commontable>
				</div>
				<div class="pagination">
					<Pagination @handleCurrentChange="handleCurrentChanges2" @handleSizeChange="handleSizeChanges2"
						:total="total2"></Pagination>
				</div>
				<div style="width: 970px;">
					<Invoicesubmissionmanagementbottom :tableDataDetail="tableDataDetail"
						:tableDataUnique="tableDataUnique" :sbmid="sbmid"></Invoicesubmissionmanagementbottom>
				</div>
			</div>
		</DialogFrom>


		<DialogFrom width="1000px" :title="invTitle" :OKASCAN="false" :dialogVisible="dialogVisibleoutboundorderedit"
			@cancel="canceloutboundorderedit1" @dialogOK="dialogOKcanceloutboundorderedit1">
			<Commonbtn backgroundColor="#FFF" title="保存" fontSize="14px" @btnclick="save"
				:src="require('@/assets/icon/bc.png')">
			</Commonbtn>
			<Commonbtn backgroundColor="#FFF" v-if="Fourelementsfalg" title="四要素校验" fontSize="14px"
				@btnclick="Fourelements" :src="require('@/assets/icon/shen.png')">
			</Commonbtn>
			<Commondown types="5" backgroundColor="#FFF" fontSize="14px" fontSizeDowns="10px" :datalist="UpLoadlist"
				@UploadTopDown="UpLoad" titles="上传" :src="require('@/assets/icon/daoc.png')">
			</Commondown>
			<div v-show="false">
				<div style="display: inline-block;margin-left: 20px;font-size: 10px">发票图片上传:</div>
				<CommonbtnUpLoad backgroundColor="#FFF" types="fileImg" id="UploadInvoicePicByEditRef" title="浏览"
					fontSize="14px" @getFile="UploadInvoicePicByEdit" :src="require('@/assets/icon/daoc.png')">
				</CommonbtnUpLoad>
				<!-- v-if="addupdateType == 2" -->
				<div style="display: inline-block;margin-left: 20px;">
					<CommonbtnUpLoad backgroundColor="#FFF" types="multiple" title="上传销货清单" fontSize="14px"
						@getFiles="UploadTopEdit" :src="require('@/assets/icon/daoc.png')">
					</CommonbtnUpLoad>
				</div>
			</div>
			<div style="height: 1px;background:rgb(240, 240, 240);width: 960px;"></div>
			<div class="froms">
				<div class="inputtop"
					style="width: 960px;height: 135px;border-bottom: 1px solid #f0f0f0;background-color: #ffffff;padding-bottom: 70px;animation: shows 0.2s linear;overflow: hidden;">
					<template v-for="(item, index) in invupdatefromdata">
						<Commondropdownlist ref="outupdate" :widths="item.widths" :inputflag="item.inputflag"
							:disabledHB="item.disabledHB" :disabled="item.disabled" :loading="loading"
							:event="item.event" @invClass="invClass" @remoteMethodtows="remoteMethodtows"
							@remoteMethodtowHB="remoteMethodtowHB" @remoteMethodtowHP="remoteMethodtowHP"
							:btx="item.btx" :options="item.options" :minrigth="item.minrigth" :maxrigth="item.maxrigth"
							:minleft="item.minleft" :maxleft="item.maxleft" :lablewith="item.lablewith"
							:inputdata="item.inputdata" :title="item.title" :fontSize="item.fontSize"
							:color="item.color" :placeholder="item.placeholder" :types="item.types"
							:inputtype="item.inputtype" :width="item.width" :content="item.content">
						</Commondropdownlist>
					</template>
					<div style="height:10px;">
					</div>
				</div>
			</div>
			<div style="width: 970px;margin-top: 10px">
				<Commonbtn v-if="showBtn" backgroundColor="#FFF" title="删除选中行" fontSize="14px" @btnclick="invDel"
					:src="require('@/assets/icon/shen.png')">
				</Commonbtn>
				<div style="display: inline-block;margin-left: 10px;color: red;" v-if="InvoiceChecked == 0">
					(允许修改)
				</div>
				<!---->
				<Commontable @onRowClick="onRowClickDialog" :InvoiceChecked="InvoiceChecked"
					@handleSelectionChange="handleSelectionChangeEdit" @Quantity522="Quantity522" :selectabletype="1"
					width="940px" colnum=5 :tableData="tableDataDespatchupdate" :headerData="headerDataDespatchupdate"
					height="100%" :Quantityflag="disabledQun" :isZheRan="disabledZhe" :loadingTable="false">
				</Commontable>
			</div>
		</DialogFrom>
		<DialogFrom width="890px" :OKASCAN="OKASCAN" :title="title" :dialogVisible="dialogVisiblesqsjg"
			@cancel="canceldrjg" @dialogOK="dialogOKdrjg">
			<div class="from">
				<Commontable @onRowClick="onRowClick" width="830px" colnum=100 :tableData="tableDataqsjg" height="100%">
				</Commontable>
			</div>
		</DialogFrom>
	</div>
</template>
<script>
import Commondropdownlist from '../../../../components/common-dropdownlist.vue'
import Commontable from '../../../../components/common-table.vue'
import Commonbtn from '../../../../components/common-btn.vue'
import Pagination from '../../../../components/pagination.vue'
import DialogFrom from '../../../../components/dialog-from.vue'
import fromdata from '../fromData/add'
import fromdataedit from '../fromData/edit'
import Dialog from '../../../../components/dialog.vue'
import Commondown from '../../../../components/common-down.vue'
import CommonbtnUpLoad from '../../../../components/common-upload.vue'
import InvAddDialogFromTable from '../components/components/invaddDialogFromTable.vue'
import CommonBtngroup from '../../../../components/commongroup.vue'
import invadd from '../fromData/invadd'
import invaddupdate from '../fromData/invaddupdate'
import headerData from './components/fromDataTable/headerData'
import headerDataTow from './components/fromDataTable/headerDataTow'
import headerDataDetail from './components/fromDataTable/headerDataDetail'
import headerDataDespatchupdate from './components/fromDataTable/headerDataDespatchupdate'
import headerDataDespatch from './components/fromDataTable/headerDataDespatch'
import VideoPlayer from '../../../../components/videoPlayer.vue'
import invTerminalHospitalfromdata from '../fromData/invTerminalHospitalfromdata'
import outformdata from './FromData/outformdata'
import utils from '../../../../common/utils'
import Invoicesubmissionmanagementbottom from './invoicesubmissionmanagement-bottom.vue'
import {
	SaleBillInfo,
	SaleBillImport,
	SaleBillDownloadTemplet,
	SaleBillDelete,
	SaleBillVerify,
	SaleBillUnVerify,
	InventoryClassInfo,
	CustomerList,
	HospitalList,
	InventoryClassList,
	HelperDPVoucherType,
	ASNVoucherType,
	CusType,
	SaleBillUploadSalesInvListPic,
	SaleBillUploadInvoicePic,
	wmsDespatchDetail,
	wmsDespatchDetailUnique,
	DespatchDetailByDPMIDs,
	SaleBillUploadInvoicePicByEdit,
	SaleBillCheckInvoicePicByStandard,
	HelperCheckWay,
	SaleBillCheckInvoiceDetail,
	wmsDespatchList,
	SaleBillList,
	SaleBillAdd,
	SaleBillEdit,
	SaleBillUploadSalesInvListByEdit,
	SaleBillDoMultiInvoiceCheckedChange,
	SaleBillChangeTerminalHospital,
	SaleBillBatchDownloadInvoicePic,
	SaleBillDetail,
	SaleBillDetailUnique,
	GetSaleBillDetailBySBMIDs
} from '@/api/home'
export default {
	components: {
		Commontable,
		Commonbtn,
		Pagination,
		DialogFrom,
		Commondropdownlist,
		Dialog,
		Commondown,
		CommonbtnUpLoad,
		InvAddDialogFromTable,
		CommonBtngroup,
		VideoPlayer,
		Invoicesubmissionmanagementbottom
	},
	props: {
		tableData: {
			type: Array,
			default: Array
		},
		total: {
			type: Number,
			default: 0
		},
		tableDataMD: {
			type: Array,
			default: Array
		},
	},
	data: function () {
		return {
			dialogVisibles: false,
			dialogVisiblesinvoicephoto: false,
			dialogVisibleshen: false,
			dialogVisibleqshen: false,
			dialogVisibleqdel: false,
			rowboo: false,
			loading: false,
			showorhide: false,
			dialogVisiblesqsjg: false,
			dialogVisibleoutboundorder: false,
			dialogVisibleoutboundorder2: false,
			dialogVisibGuidanceVideo: false,
			editops: true,
			tableflag: true,
			tableflags: false,
			dialogVisibleoutboundorderedit: false,
			Fourelementsfalg: false, //四要素按钮是否显示
			savefalg: false,
			OKASCAN: true,
			sbpdidFalg: false,
			dialogVisibTerminalHospital: false,
			loadingTable: false, //选择出库单下方小表格的loading
			OutAddLoading: false, //选择出库单的加载loading
			showorhide: true,
			InvoiceChecked: null,
			addupdateType: 0,
			InvoiceCheckeds: null,
			InvoiceValue: "",
			InvoiceRemark: "",
			getText: "",
			GetTexts: "",
			rigthText: "确认",
			invTitle: "修改发票",
			dpmid: "",
			CusCodes: "",
			FileName: "",
			SellerType: "",
			pageindex: 1,
			pageSize: 20,
			dpmiDsarr: [],
			tableDataqsjg: [],
			invaddfromdata: [],
			invupdatefromdata: [],
			tableDataDespatchupdate: [],
			invTerminalHospitalfromdata: [],
			outformdata: [],
			sbmidarr: [],
			tableDataDespatch: [],
			DesData: [],
			headerDataTow: [],
			availabilityData: [],
			editRowTableData: null,
			sbmid: '',
			imagePath: [],
			imagePathOne: '',
			availability: 0,
			totals: 0,
			isStandardCheck: 0,
			title: "导入结果",
			UpLoadlist: [{
				title: '上传发票图片',
				methodName: 'LIU',
				type: 'file',
				src: require('@/assets/icon/daoc.png')
			},
			{
				title: '上传销货清单',
				methodName: 'LIUQD',
				type: 'files',
				src: require('@/assets/icon/daoc.png')
			},
			],
			state: [{
				title: '明细'
			},
			{
				title: '唯一码'
			}
			],
			qx: {
				add: false,
				update: false,
				del: false,
				stopif: true,
				daoc: true,
				assignment: false,
				enabled: false,
				submit: false,
				skip: false, //跳过
				reset: false, //重置
				revoke: false, //弃审
				changeth: false, //弃审
			},
			headerDataUnique: [{
				prop: 'id',
				label: '序号',
				columnwidth: 120
			},
			{
				prop: 'Batch',
				label: '批号',
				columnwidth: 260
			},
			{
				prop: 'InvUniqueCode',
				label: '唯一码',
				columnwidth: 450
			},
			{
				prop: 'Quantity',
				label: '数量',
				columnwidth: 450
			},
			],
			headerDataDespatchupdate: [],
			headerDataDetail: [],
			headerData: [],
			headerDataDespatch: [],
			fromdatalists: [{
				inputdata: '',
				fontSize: '14px',
				color: '#333333',
				placeholder: '颜色说明',
				types: '',
				inputtype: 'selects',
				width: '110px',
			},],
			downlist: [{
				title: '未上传发票照片',
				colors: "#C0696B"
			},
			{
				title: '上传发票照片未通过',
				colors: "red"
			},
			],
			AddTableSelectiondetailList: [],
			AddTableSelectiondetailUniqueList: [],
			tableDataDetailUnique: [],
			tableDataDetail: [],
			CusTypeFlog: null,
			onchage: 0,
			InvAddCode: "",
			InvName: "",
			Quantity: "",
			TaxUnitPrice: "",
			TerminalHPName: "",
			TerminalHPID: "",
			outFrom: {
				vouCode: "",
				objName: "",
				dpDate1: "",
				dpDate2: "",
				invClass: "",
				voucherType: "",
				verifyTime1: "",
				verifyTime2: "",
				invAddCode: "",
				invName: "",
				batch: "",
			},
			options11: [{
				lable: "0",
				value: "驳回"
			},
			{
				lable: "1",
				value: "通过"
			},
			{
				lable: "4",
				value: "已处理"
			}
			],
			options1: [{
				lable: "0",
				value: "驳回"
			},],
			options2: [{
				lable: "1",
				value: "通过"
			}],
			selectformdata: [{
				inputdata: '',
				title: '发票号码',
				fontSize: '14px',
				color: '#333333',
				placeholder: '请输入',
				types: 'text',
				inputtype: 'input',
				width: '160px',
				lablewith: '95px'
			},
			{
				inputdata: '',
				title: '付款方名称',
				fontSize: '14px',
				color: '#333333',
				placeholder: '请输入',
				types: 'text',
				inputtype: 'input',
				width: '160px',
				disabled: false,
				lablewith: '95px'
			},
			{
				inputdata: '',
				title: '开票金额',
				fontSize: '14px',
				color: '#333333',
				placeholder: '请输入',
				types: '',
				inputtype: 'numbers',
				width: '74px',
				lablewith: '95px',
				minleft: 0,
				// maxleft: 100,
				minrigth: 0,
				// maxrigth: 100
			},
			{
				inputdata: '',
				title: "入库日期",
				fontSize: "14px",
				color: "#333333",
				placeholder: "请输入",
				types: "",
				inputtype: "date",
				width: "160px",
				lablewith: '100px'
			},
			{
				inputdata: '',
				title: "开票日期",
				fontSize: "14px",
				color: "#333333",
				placeholder: "请输入",
				types: "",
				inputtype: "date",
				width: "160px",
				lablewith: '95px'
			},
			{
				inputdata: '',
				title: '产品型号/名称',
				fontSize: '14px',
				color: '#333333',
				placeholder: '请输入',
				types: 'text',
				inputtype: 'input',
				width: '160px',
				lablewith: '120px'
			},
			{
				inputdata: '',
				title: "审核日期",
				fontSize: "14px",
				color: "#333333",
				placeholder: "请输入",
				types: "",
				inputtype: "date",
				width: "160px",
				lablewith: '90px'
			},
			{
				inputdata: '',
				title: '出库单号',
				fontSize: '14px',
				color: '#333333',
				placeholder: '请输入',
				types: 'text',
				inputtype: 'input',
				width: '160px',
				lablewith: '80px'
			},
			{
				inputdata: '',
				title: '发票方向',
				fontSize: '14px',
				color: '#333333',
				placeholder: '全部',
				types: '',
				inputtype: 'select',
				width: '160px',
				lablewith: '80px',
				options: [{
					value: '蓝票',
					key: '0'
				}, {
					value: '红票',
					key: '1'
				},]
			},
			{
				inputdata: '',
				title: '产品线',
				fontSize: '14px',
				color: '#333333',
				placeholder: '全部',
				types: '',
				inputtype: 'select',
				width: '160px',
				lablewith: '80px',
				options: [

				]
			},
			{
				inputdata: '',
				title: '终端医院',
				fontSize: '14px',
				color: '#333333',
				placeholder: '请输入',
				types: 'text',
				inputtype: 'input',
				width: '160px',
				lablewith: '80px'
			},
			],
			selectformparams: {},
			selectformdatalist: [],
			headerDataDespatch: [],
			tableDataDespatch2: [],
			total2: 0,
			pageSize2: 20,
			pageIndex2: 1,
			tableDataDetail: [],
			tableDataUnique: [],
			sbmid: "",
			salesType: {
				11: '红冲',
				12: '折让',
				13: '作废',
				0: '蓝字'
			},
			disabledQun: false,
			disabledZhe: false,
			showBtn: false,
		}
	},
	mounted() {
		this.fromdataadd = JSON.parse(JSON.stringify(fromdata))
		this.fromdataedit = JSON.parse(JSON.stringify(fromdataedit))
		this.invaddfromdata = JSON.parse(JSON.stringify(invadd))
		this.invupdatefromdata = JSON.parse(JSON.stringify(invaddupdate))
		this.headerData = JSON.parse(JSON.stringify(headerData))
		this.headerDataDetail = JSON.parse(JSON.stringify(headerDataDetail))
		this.headerDataDespatchupdate = JSON.parse(JSON.stringify(headerDataDespatchupdate))
		this.headerDataDespatch = JSON.parse(JSON.stringify(headerDataDespatch))
		this.headerDataTow = JSON.parse(JSON.stringify(headerDataTow))
		this.invTerminalHospitalfromdata = JSON.parse(JSON.stringify(invTerminalHospitalfromdata))
		this.outformdata = JSON.parse(JSON.stringify(outformdata))
		this.QX()
	},
	methods: {
		QX() {
			let data = JSON.parse(localStorage.getItem("MenusData"))
			data.Menus.map((item, index) => {
				if (item.NodeID == 16) {
					item.Nodes.map((items, indexs) => {
						if (items.NodeID == 17) {
							this.qus = items.Nodes
						}
					})
				}
			})
			//console.log(this.qus, "this.qus");
			if (this.qus) {
				this.qus.map((item, index) => {
					if (item.NodeName == 'add') {
						this.qx.add = true
					} else if (item.NodeName == 'edit') {
						this.qx.update = true
					} else if (item.NodeName == 'delete') {
						this.qx.del = true
					} else if (item.NodeName == 'stopif') {
						this.qx.del = true
					} else if (item.NodeName == 'assignment') {
						this.qx.assignment = true
					} else if (item.NodeName == 'enabled') {
						this.qx.enabled = true
					} else if (item.NodeName == 'skip') {
						this.qx.skip = true
					} else if (item.NodeName == 'reset') {
						this.qx.reset = true
					} else if (item.NodeName == 'changeth') {
						this.qx.changeth = true
					}
				})
			}
			this.CusType()
		},
		tabClick(index) {
			if (index == 0) {
				this.tableflag = true
				this.tableflags = false
				this.wmsDespatchDetail()
			}
			if (index == 1) {
				this.tableflag = false
				this.tableflags = true
				this.wmsDespatchDetailUnique()
			}
			if (this.onchage != index) {
				this.onchage = index
			}
		},
		UpLoad(obj) {
			console.log(obj);
			if (obj.index == 0) {
				this.UploadInvoicePicByEdit(obj.file)
			}
			if (obj.index == 1) {
				this.UploadTopEdit(obj.file)
			}
		},
		// 出库单列表
		async despatchList() {
			const loading = this.$loading({
				lock: true,
				text: '正在加载出库单列表...',
				spinner: 'el-icon-loading',
				background: 'rgba(255,255,255,0.3)'
			});
			this.OutAddLoading = true
			let {
				data,
				code,
				message
			} = await wmsDespatchList({
				vouCode: this.outFrom.vouCode,
				objName: this.outFrom.objName,
				dpDate1: this.outFrom.dpDate1,
				dpDate2: this.outFrom.dpDate2,
				invClass: this.outFrom.invClass,
				voucherType: this.outFrom.voucherType,
				verifyTime1: this.outFrom.verifyTime1,
				verifyTime2: this.outFrom.verifyTime2,
				invAddCode: this.outFrom.invAddCode,
				invName: this.outFrom.invName,
				batch: this.outFrom.batch,
				pageSize: this.pageSize,
				pageIndex: this.pageindex,
				referToBill: 1
			})
			if (code == 0) {
				this.totals = data.Count
				this.tableDataDespatch = data.data


				this.dialogVisibleoutboundorder = true
			} else {
				this.$message({
					type: "error",
					message: message
				})
			}
			this.OutAddLoading = false
			loading.close();
		},
		// 出库明细
		async wmsDespatchDetail() {
			this.loadingTable = true
			let {
				data,
				code,
				message
			} = await wmsDespatchDetail({
				dpmid: this.dpmid
			})
			if (code == 0) {
				this.tableDataDetail = data
			} else {
				this.$message.warning(message)
			}
			this.loadingTable = false
		},
		// 出库唯一码
		async wmsDespatchDetailUnique() {
			this.loadingTable = true
			let {
				data,
				code
			} = await wmsDespatchDetailUnique({
				dpmid: this.dpmid
			})
			if (code == 0) {
				this.tableDataDetailUnique = data
			} else {
				this.$message.warning(message)
			}
			this.loadingTable = false
		},
		handleCurrentChanges(pageindex) {
			this.pageindex = pageindex
			this.despatchList()
		},
		handleSizeChanges(paegSzie) {
			this.pageSize = paegSzie
			this.despatchList()
		},
		// 详情
		async SaleBillInfo() {
			const loading = this.$loading({
				lock: true,
				text: '正在加载详情...',
				spinner: 'el-icon-loading',
				background: 'rgba(255,255,255,0.3)'
			});

			let {
				code,
				data,
				message
			} = await SaleBillInfo({
				sbmid: this.sbmid
			})
			if (code == 0) {
				this.$refs.outupdate[0].modelvalue = data.InvoiceNo
				this.$refs.outupdate[1].modelvalue = data.SBDate
				this.$refs.outupdate[2].modelvalue = data.CheckWay
				this.$refs.outupdate[3].modelvalue = data.VouCode
				this.$refs.outupdate[4].modelvalue = data.VerifyCode
				this.$refs.outupdate[5].modelvalue = data.SBCode
				this.$refs.outupdate[6].modelvalue = data.Remark
				this.$refs.outupdate[7].modelvalue = data.InvoiceAmt
				this.$refs.outupdate[8].modelvalue = data.ReturnName
				this.$refs.outupdate[9].modelvalue = data.Hospital ? data.Hospital : '';
				this.$refs.outupdate[10].modelvalue = data.TerminalHPName
				this.$refs.outupdate[11].modelvalue = data.RedType
				this.invupdatefromdata[11].options = [{
					value: data.RedTypeName,
					key: data.RedType
				}]


				if (!data.Hospital) {
					this.invupdatefromdata[9].disabledHB = false;
				} else {
					this.invupdatefromdata[9].options = [{
						key: data.Hospital,
						value: data.CusName
					}]
				}

				this.disabledQun = data.RedType === 12 || data.RedType === 13 ? true : false;
				this.disabledZhe = data.RedType === 12 ? true : false;
				this.showBtn = data.RedType === 13 ? false : true;
				//console.log(this.invupdatefromdata[11], 9999999999);
				this.tableDataDespatchupdate = data.DetailList
				this.CusCodes = data.CusCode
				this.SellerType = data.SellerType
				this.TerminalHPName = data.TerminalHPName
				this.TerminalHPID = data.TerminalHPID
				// if (data.SellerType == '医院') {
				//   this.invupdatefromdata[10].disabled = true //终端医院
				// }
				this.invupdatefromdata[10].disabledHB = true //终端医院
				// this.imagePath = data.InvListImage
				this.sbpdid = data.InvoicePicImage
				this.getText = data.InvoicePicImage.GetText

				this.$refs.outupdate[9].inputflag = true
			} else {
				this.$message({
					type: 'warning',
					message: message
				})
			}
			loading.close();
		},
		// 下载导入模板
		async SaleBillDownloadTemplet() {
			// 测试
			// this.downURL = "https://bs.oudot.cn/Download/入库单导入模板(一级经销商).xlsx"
			let {
				data,
				code,
				message
			} = await SaleBillDownloadTemplet({})
			if (code == 0) {
				window.location.href = data
			} else if (code == 101) {
				this.$message({
					type: 'warning',
					message: message
				});
			} else {
				this.$message({
					type: 'error',
					message: message
				});
			}
		},
		// 导入
		async SaleBillImport(file) {
			const loading = this.$loading({
				lock: true,
				text: '正在导入...',
				spinner: 'el-icon-loading',
				background: 'rgba(255,255,255,0.3)'
			});
			let formdata = new FormData()
			formdata.append('file', file)
			let {
				data,
				code,
				message
			} = await SaleBillImport(formdata)
			if (code == 0) {
				this.$message({
					type: 'success',
					message: message
				});
			} else if (code == 101) {
				this.$message({
					type: 'warning',
					message: message
				});
			} else {
				this.dialogVisiblesqsjg = true
				this.tableDataqsjg = data
				this.title = "导入结果"
				this.$message({
					type: 'error',
					message: message
				});
			}
			this.$parent.saleBillList()
			loading.close();
		},
		// 删除
		async saleBillDelete() {
			let arr = []
			this.sbmidarr.map((item, index) => {
				arr.push(item.SBMID)
			})
			let {
				code,
				data,
				message
			} = await SaleBillDelete({
				sbmiDs: arr
			})
			if (code == 0) {
				this.$message({
					type: 'success',
					message: '删除成功'
				});
				this.sbmidarr = []

			} else if (code == 2 || code == 1) {
				this.title = "删除结果"
				this.dialogVisiblesqsjg = true
				this.tableDataqsjg = data
				this.$message({
					type: 'warning',
					message: message
				});
			} else {
				this.$message({
					type: 'error',
					message: message
				});
			}
			this.$refs.refTableCenter.$refs.fileTableSelect.clearSelection()
			this.$parent.saleBillList()
			this.rowboo = false
		},
		// 审核
		async saleBillVerify() {
			let arr = []
			this.sbmidarr.map((item, index) => {
				arr.push(item.SBMID)
			})
			let {
				code,
				message,
				data
			} = await SaleBillVerify({
				sbmiDs: arr
			})
			if (code == 0) {
				this.$message({
					type: 'success',
					message: '审核成功'
				});
				this.sbmidarr = []

			} else {
				this.title = "审核结果"
				this.dialogVisiblesqsjg = true
				this.tableDataqsjg = data
				this.$message({
					type: 'error',
					message: message
				});
			}
			this.$parent.saleBillList()
			this.$refs.refTableCenter.$refs.fileTableSelect.clearSelection()
			this.rowboo = false
		},
		// 弃审
		async saleBillUnVerify() {
			let arr = []
			this.sbmidarr.map((item, index) => {
				arr.push(item.SBMID)
			})
			let {
				code,
				message,
				data
			} = await SaleBillUnVerify({
				sbmiDs: arr
			})
			if (code == 0) {
				this.$message({
					type: 'success',
					message: '弃审成功'
				});
				this.sbmidarr = []
			} else {
				this.title = "弃审结果"
				this.dialogVisiblesqsjg = true
				this.tableDataqsjg = data
				this.$message({
					type: 'error',
					message: message
				});
			}
			this.$parent.saleBillList()
			this.$refs.refTableCenter.$refs.fileTableSelect.clearSelection()
			this.rowboo = false
		},
		// 发票照片上传
		async UploadInvoicePicByEdit(file) {
			const loading = this.$loading({
				lock: true,
				text: '正在上传...',
				spinner: 'el-icon-loading',
				background: 'rgba(255,255,255,0.3)'
			});
			let formdata = new FormData()
			formdata.append('file', file)
			let {
				code,
				data,
				message
			} = await SaleBillUploadInvoicePicByEdit(formdata)

			if (code == 0) {
				this.$refs.outupdate[0].modelvalue = data.InvoiceNo
				this.$refs.outupdate[1].modelvalue = data.SBDate
				this.$refs.outupdate[2].modelvalue = data.CheckWay
				this.$refs.outupdate[4].modelvalue = data.VerifyCode
				this.$refs.outupdate[5].modelvalue = data.SBCode
				this.$refs.outupdate[7].modelvalue = data.InvoiceAmt
				this.FileName = data.FileName
				this.getText = data.GetText
				this.sbpdid = null
				this.invupdatefromdata.map((item, index) => {
					if (index == 6) {
						item.disabled = false
					} else {
						item.disabled = true
					}
					this.savefalg = true
				})
				// this.$message({
				//   type: 'success',
				//   message: message
				// });
				this.Fourelementsfalg = false
				loading.close();
			} else if (code == 3) {
				if (data.OCRSuccess) {
					this.$refs.outupdate[0].modelvalue = data.InvoiceNo
					this.$refs.outupdate[1].modelvalue = data.SBDate
					this.$refs.outupdate[2].modelvalue = data.CheckWay
					this.$refs.outupdate[4].modelvalue = data.VerifyCode
					this.$refs.outupdate[5].modelvalue = data.SBCode
					this.$refs.outupdate[7].modelvalue = data.InvoiceAmt
					// this.FileName = data.FileName
					this.getText = data.GetText
					this.sbpdid = null
					this.imagePathOne;
					this.invupdatefromdata.map((item, index) => {
						if (index == 6 || index == 1 || index == 0 || index == 2 || index == 4 || index ==
							5 || index == 7) {
							item.disabled = false
						} else {
							item.disabled = true
						}
						this.savefalg = true
					})
					this.savefalg = false
					this.Fourelementsfalg = true
					this.$message({
						type: 'error',
						message: message
					});
					// this.$refs.outupdate.map((item, index) => {
					//   item.disabled = true
					// })
					loading.close();
				} else {
					this.invupdatefromdata.map((item, index) => {
						if (index == 6 || index == 1 || index == 0 || index == 2 || index == 4 || index ==
							5 || index == 7) {
							item.disabled = false
						} else {
							item.disabled = true
						}
						this.savefalg = true
					})
					this.savefalg = false
					this.Fourelementsfalg = true
					this.$message({
						type: 'error',
						message: message
					});
					// this.$refs.outupdate.map((item, index) => {
					//   item.disabled = true
					// })
					loading.close();
				}
				this.FileName = data.FileName
			} else {
				this.$message({
					type: 'error',
					message: message
				});
				loading.close();
			}
			this.sbpdidFalg = true
			loading.close();
		},
		Fourelements() {
			this.saleBillCheckInvoicePicByStandard(this.$refs.outupdate)
		},
		async saleBillCheckInvoicePicByStandard(dataList) {
			if (dataList[1].modelvalue == "") {
				this.$message({
					type: 'warning',
					message: "开票日期不能为空"
				});
				return false
			}
			if (dataList[2].modelvalue == "") {
				this.$message({
					type: 'warning',
					message: "发票类型不能为空"
				});
				return false
			}
			let {
				code,
				data,
				message
			} = await SaleBillCheckInvoicePicByStandard({
				invoiceNo: dataList[0].modelvalue,
				sbDate: dataList[1].modelvalue,
				checkWay: dataList[2].modelvalue,
				verifyCode: dataList[4].modelvalue,
				sbCode: dataList[5].modelvalue,
				invoiceAmt: dataList[7].modelvalue,
			})
			if (code == 0) {
				this.isStandardCheck = 1
				this.getText = data.GetText
				this.savefalg = true
				this.invupdatefromdata[7].disabled = true
				this.$message({
					type: "success",
					message: message
				})
			} else {
				this.$message({
					type: "warning",
					message: message
				})
			}

		},
		// 新增
		async SaleBillAdd() {
			let {
				code,
				data,
				message
			} = await SaleBillAdd({
				sbmid: "",
				ReturnFlag: this.$refs.outupdate[8].modelvalue == '红票' ? 1 : 0,
				RedType: this.$refs.outupdate[11].modelvalue,
				sbCode: this.$refs.outupdate[5].modelvalue, //发票代码
				invoiceNo: this.$refs.outupdate[0].modelvalue, //发票号码
				sbDate: this.$refs.outupdate[1].modelvalue, //开票日期
				returnFlag: this.returnFlag, //选择的出库是销售订单传0；选择出库是销售退货单传1
				remark: this.$refs.outupdate[6].modelvalue, //备注
				verifyCode: this.$refs.outupdate[4].modelvalue, //校验码
				checkWay: this.$refs.outupdate[2].modelvalue, //发票类型
				invoiceAmt: this.$refs.outupdate[7].modelvalue, //发票照片上的无税金额
				cusCode: this.DesData.CusCode, //客户
				hospital: this.$refs.outupdate[9].modelvalue, //医院
				lstInvListPicUrl: this.imagePath, //销货清单文件名（修改状态下，未重新上传，则不传）
				detailList: this.tableDataDespatchupdate, //发票明细
				imageInPut: {
					sbpdid: null, //加载时获取照片时拿到的SBPDID（修改时未重新上传照片则不传）
					imagePath: this.FileName, //发票文件名（修改时未重新上传照片则不传）
					availability: this.availability, //发票内容是否校验通过（0：未通过；1：通过）即④号接口是否返回true
					getText: this.getText, //发票照片上传时获取的GetText
					isStandardCheck: this.isStandardCheck, //是否四要素校验（0：未调用四要素接口；1：调用过四要素接口）
					errMessage: JSON.stringify(this
						.availabilityData) //接口/api/sms/SaleBill/CheckInvoiceDetail返回的data内容
				}, //发票照片内容
				TerminalHPID: this.$refs.outupdate[10].modelvalue == this.TerminalHPName ? this
					.TerminalHPID : this.$refs.outupdate[10].modelvalue
			})
			if (code == 0) {
				this.$message({
					type: "success",
					message: message
				})
				this.dialogVisiblesdrjg = false
				this.dialogVisibleoutboundorderedit = false
				this.$refs.outupdate.map((item, index) => {
					item.modelvalue = ""
				})
				this.tableDataDespatchupdate.length = 0
				this.$parent.saleBillList()
			} else if (code == 200) {
				this.$confirm('被红冲的蓝票是否重开？<br/>【是】：请提交重开的蓝票<br/>【否】：请操作销售退货单还原库存', '提示', {
					confirmButtonText: '否',
					cancelButtonText: '是',
					distinguishCancelAndClose: true,
					type: 'warning',
					dangerouslyUseHTMLString: true,
					showClose: false
				}).then(() => {
					this.$router.push({
						path: '/WMS/Despatch',
						query: {
							DPMIDs: data.join(','),
							openAdd: true,
							NodeID: 20
						}
					})
				}).catch(async action => {
					if (action === 'cancel') {
						const loading = this.$loading({
							lock: true,
							text: '正在加载...',
							spinner: 'el-icon-loading',
							background: 'rgba(255,255,255,0.3)'
						});
						let res = await DespatchDetailByDPMIDs({
							dpmiDs: data,
							IsDirect: 1
						})
						if (res.code == 0) {
							this.invTitle = "新增发票"
							this.dialogVisiblesdrjg = false
							this.dialogVisibleoutboundorderedit = false
							this.dialogVisibleoutboundorder = false
							setTimeout(() => {
								this.dialogVisibleoutboundorderedit = true
								setTimeout(() => {
									this.populateInvoiceData(res.data)
									loading.close()
								}, 200)
							}, 200)
						} else {
							this.$message.error(res.message)
							loading.close()
						}
					}
				});
			} else if (code == 101) {
				this.$message({
					type: "warning",
					message: message
				})
			} else {
				this.$message({
					type: "error",
					message: message
				})
			}
		},
		// 修改
		async SaleBillEdit() {
			let {
				code,
				data,
				message
			} = await SaleBillEdit({
				sbmid: this.sbmid,
				ReturnFlag: this.$refs.outupdate[8].modelvalue == '红票' ? 1 : 0,
				RedType: this.$refs.outupdate[11].modelvalue,
				sbCode: this.$refs.outupdate[5].modelvalue, //发票代码
				invoiceNo: this.$refs.outupdate[0].modelvalue, //发票号码
				sbDate: this.$refs.outupdate[1].modelvalue, //开票日期
				returnFlag: this.returnFlag, //选择的出库是销售订单传0；选择出库是销售退货单传1
				remark: this.$refs.outupdate[6].modelvalue, //备注
				verifyCode: this.$refs.outupdate[4].modelvalue, //校验码
				checkWay: this.$refs.outupdate[2].modelvalue, //发票类型
				invoiceAmt: this.$refs.outupdate[7].modelvalue, //发票照片上的无税金额
				cusCode: this.DesData.CusCode, //客户
				hospital: this.$refs.outupdate[9].modelvalue, //医院 //医院
				lstInvListPicUrl: this.imagePath, //销货清单文件名（修改状态下，未重新上传，则不传）
				detailList: this.tableDataDespatchupdate, //发票明细
				imageInPut: {
					sbpdid: this.sbpdidFalg ? null : this.sbpdid.SBPDID, //加载时获取照片时拿到的SBPDID（修改时未重新上传照片则不传）
					imagePath: this.FileName, //发票文件名（修改时未重新上传照片则不传）
					availability: this.availability, //发票内容是否校验通过（0：未通过；1：通过）即④号接口是否返回true
					getText: this.getText, //发票照片上传时获取的GetText
					isStandardCheck: this.isStandardCheck, //是否四要素校验（0：未调用四要素接口；1：调用过四要素接口）
					errMessage: JSON.stringify(this
						.availabilityData) //接口/api/sms/SaleBill/CheckInvoiceDetail返回的data内容
				}, //发票照片内容
				TerminalHPID: this.$refs.outupdate[10].modelvalue == this.TerminalHPName ? this
					.TerminalHPID : this.$refs.outupdate[10].modelvalue
			})
			if (code == 0) {
				this.$message({
					type: "success",
					message: message
				})
				this.dialogVisiblesdrjg = false
				this.dialogVisibleoutboundorderedit = false
				this.dialogVisibleoutboundorder2 = false;
				this.tableDataDespatchupdate.length = 0
				this.$parent.saleBillList()
			} else if (code == 200) {
				this.$confirm('被红冲的蓝票是否重开？', '提示', {
					confirmButtonText: '是',
					cancelButtonText: '否',
					distinguishCancelAndClose: true,
					type: 'warning'
				}).then(async () => {
					const loading = this.$loading({
						lock: true,
						text: '正在加载...',
						spinner: 'el-icon-loading',
						background: 'rgba(255,255,255,0.3)'
					});
					let res = await DespatchDetailByDPMIDs({
						dpmiDs: data,
						IsDirect: 1
					})
					if (res.code == 0) {
						this.invTitle = "新增发票"
						this.dialogVisiblesdrjg = false
						this.dialogVisibleoutboundorderedit = false
						this.dialogVisibleoutboundorder = false
						setTimeout(() => {
							this.dialogVisibleoutboundorderedit = true
							setTimeout(() => {
								this.populateInvoiceData(res.data)
								loading.close()
							}, 200)
						}, 200)
					} else {
						this.$message.error(res.message)
						loading.close()
					}
				}).catch(action => {
					if (action === 'cancel') {
						this.$router.push({
							path: '/WMS/Despatch',
							query: {
								DPMIDs: data.join(','),
								openAdd: true,
								NodeID: 20
							}
						})
					}
				});
			} else if (code == 101) {
				this.$message({
					type: "warning",
					message: message
				})
			} else {
				this.$message({
					type: "error",
					message: message
				})
			}

		},
		populateInvoiceData(data) {
			try {
				this.$refs.outupdate[3].modelvalue = data.VouCodes
				this.$refs.outupdate[8].modelvalue = data.ReturnFlag == 0 ? "蓝票" : "红票"
				this.$refs.outupdate[9].modelvalue = data.Hospital ? data.Hospital : '';
				this.$refs.outupdate[10].modelvalue = data.TerminalHPName
				this.TerminalHPID = data.TerminalHPID
				this.TerminalHPName = data.TerminalHPName
				this.invupdatefromdata[10].disabledHB = true

				if (!data.Hospital) {
					this.invupdatefromdata[9].disabledHB = false;
				} else {
					this.invupdatefromdata[9].options = [{
						key: data.Hospital,
						value: data.CusName
					}]
				}
			} catch (error) {
				console.log(error);
			}
			this.showBtn = true
			this.DesData = data
			this.tableDataDespatchupdate = data.data
			if (this.CusTypeFlog == 1) {
				this.invupdatefromdata[8].inputflag = true
			}
			if (this.CusTypeFlog == 2) {
				this.invupdatefromdata[9].inputflag = true
			}
			this.invupdatefromdata[7].disabled = false
			this.$forceUpdate();
		},
		// 发票内容校验
		async SaleBillCheckInvoiceDetail() {
			if (this.$refs.outupdate[0].modelvalue == "") {
				this.$message({
					type: 'warning',
					message: "开票号不能为空"
				});
				return false
			}
			if (this.$refs.outupdate[1].modelvalue == "") {
				this.$message({
					type: 'warning',
					message: "开票日期不能为空"
				});
				return false
			}
			if (this.$refs.outupdate[2].modelvalue == "") {
				this.$message({
					type: 'warning',
					message: "发票类型不能为空"
				});
				return false
			}
			// if (this.$refs.outupdate[5].modelvalue == "") {
			// 	this.$message({
			// 		type: 'warning',
			// 		message: "发票代码不能为空"
			// 	});
			// 	return false
			// }
			let arr = []
			this.tableDataDespatchupdate.map((item, index) => {
				let obj = {
					invAddCode: item.InvAddCode,
					invName: item.InvName,
					vouCode: item.VouCode,
					quantity: item.Quantity,
					taxUnitPrice: item.TaxUnitPrice,
					CorCode: item.CorCode,
					CorID: item.CorID,
					CorsID: item.CorsID,
					Sum: item.Sum
				}
				arr.push(obj)
			})
			let {
				code,
				data,
				message
			} = await SaleBillCheckInvoiceDetail({
				SBMID: this.addupdateType == 1 ? this.sbmid : "",
				getText: this.getText,
				detailList: arr,
				lstInvListPicUrl: this.imagePath,
				ReturnFlag: this.$refs.outupdate[8].modelvalue == '红票' ? 1 : 0,
				RedType: this.$refs.outupdate[11].modelvalue,
				hospital: this.$refs.outupdate[9].modelvalue,
			})
			if (code == 0) {
				this.availability = 1
				if (this.addupdateType == 2) {
					this.SaleBillAdd()
				}
				if (this.addupdateType == 1) {
					this.SaleBillEdit()
				}
				this.$message({
					type: 'success',
					message: message
				})
			} else if (code == 1) {
				this.dialogVisiblesqsjg = true
				this.tableDataqsjg = data
				this.OKASCAN = true
				this.title = "  结果"
				this.rigthText = "保存"
			} else if (code == 2) {
				console.log("code:", code);
				this.dialogVisiblesqsjg = true
				this.tableDataqsjg = data
				this.title = "结果"
				this.OKASCAN = false
			} else {
				this.$message({
					type: "warning",
					message: message
				})
			}
			this.availabilityData = data
		},
		// 修改->保存
		save() {
			this.SaleBillCheckInvoiceDetail()
		},
		// 修改->删除选中项
		invDel() {
			var set = this.tableDelArr.map(item => item.SBDID)
			//console.log(this.tableDelArr,'set');
			var resArr = this.tableDataDespatchupdate.filter(item => !set.includes(item.SBDID))
			this.tableDataDespatchupdate = resArr
		},
		remoteMethodtowHB(query) {
			let objHosType = {
				key: 'HosType',
				value: '医院'
			}
			this.HospitalList(query, objHosType, 'HosType')
			console.log(query, 'query');
		},
		async remoteMethodtowHP(query) {
			this.loading = true
			let {
				data,
				code,
				message
			} = await HospitalList({
				hpName: query
			})
			if (code == 0) {
				this.invupdatefromdata[9].options = []
				data.data.map((item, index) => {
					let obj = {
						key: item.HPID,
						value: item.HPName
					}
					this.invupdatefromdata[9].options.push(obj)
				})
				this.loading = false
			} else {
				this.$message.warning(message)
			}
		},
		// 变更终端医院 - start
		async remoteMethodtowHBTerminalHospital(query) {
			let objHosType = {
				key: 'HosType',
				value: '医院'
			}
			this.HospitalList(query, objHosType, 'TerminalHospital')
		},

		async SaleBillChangeTerminalHospital() {
			let arr = []
			this.sbmidarr.map((item, index) => {
				arr.push(item.SBMID)
			})
			let {
				code,
				data,
				message
			} = await SaleBillChangeTerminalHospital({
				sbmiDs: arr,
				terminalHPID: this.$refs.outTerminalHospital[0].modelvalue,
			})
			if (code == 0) {
				this.$message.success('变更成功')
				this.dialogVisibTerminalHospital = false
			} else if (code == 1) {
				this.dialogVisiblesqsjg = true
				this.tableDataqsjg = data
				this.title = "变更终端医院结果"
				this.dialogVisibTerminalHospital = false
				this.$message({
					type: 'error',
					message: message
				});

			} else {
				this.$message.warning(message)
			}
		},
		TerminalHospital() {
			if (this.sbmidarr.length > 0) {
				this.dialogVisibTerminalHospital = true
				return
			}
			this.$message({
				type: 'error',
				message: '请选择您要操作的数据！'
			});
		},
		dialogOKTerminalHospital() {
			this.SaleBillChangeTerminalHospital()
		},
		cancelTerminalHospital() {
			this.dialogVisibTerminalHospital = false
		},
		// 变更终端医院 - end
		// 明细
		async HelperCheckWay() {
			const loading = this.$loading({
				lock: true,
				text: '正在加载中...',
				spinner: 'el-icon-loading',
				background: 'rgba(255,255,255,0.3)'
			});
			let {
				code,
				data,
				message
			} = await HelperCheckWay({})
			if (code == 0) {
				this.invupdatefromdata[2].options = []
				data.map((item, index) => {
					let obj = {
						key: item.Value,
						value: item.Text
					}
					this.invupdatefromdata[2].options.push(obj)
				})
			} else {
				this.$message.warning(message)
			}
			// loading.close();
		},
		onRowClickAdd(val) {
			this.editRowTableData = val
			this.dpmid = val.DPMID

			// if (this.invTitle != '修改发票') {

			// }
			this.wmsDespatchDetail()
			this.wmsDespatchDetailUnique()
		},
		onRowClickDialog(val) {
			this.editRowTableData = val
			this.dpmid = val.DPMID
		},
		UnImport() {

		},
		dowload() {

		},

		showclick() {
			this.showorhide = true
		},
		hide() {
			this.showorhide = false

		},
		Outselect() {
			this.pageindex = 1
			this.outFrom.vouCode = this.$refs.OutselectRef[0].modelvalue
			this.outFrom.dpDate1 = this.$refs.OutselectRef[1].startTime
			this.outFrom.dpDate2 = this.$refs.OutselectRef[1].endTime
			this.outFrom.objName = this.$refs.OutselectRef[2].modelvalue
			this.outFrom.invClass = this.$refs.OutselectRef[3].modelvalue
			this.outFrom.verifyTime1 = this.$refs.OutselectRef[4].startTime
			this.outFrom.verifyTime2 = this.$refs.OutselectRef[4].endTime
			this.outFrom.voucherType = this.$refs.OutselectRef[5].modelvalue
			this.outFrom.invAddCode = this.$refs.OutselectRef[6].modelvalue
			this.outFrom.invName = this.$refs.OutselectRef[7].modelvalue
			this.outFrom.batch = this.$refs.OutselectRef[8].modelvalue
			this.despatchList()

		},
		Outreset() {
			this.$refs.OutselectRef.map((item, index) => {
				if (index == 1 || index == 4) {
					item.startTime = ""
					item.endTime = ""
				}
				item.modelvalue = ""
			})
		},
		addclick() { },
		handleSelectionChangeAddDialogFromTable(val) {
			this.AddTableSelectiondetailList = val
		},
		handleSelectionChanges() {
			this.AddTableSelectiondetailUniqueList = val
		},
		async DespatchDetailByDPMIDs() {
			const loading = this.$loading({
				lock: true,
				text: '正在加载列表...',
				spinner: 'el-icon-loading',
				background: 'rgba(255,255,255,0.3)'
			});
			let dpArr = []
			this.dpmiDsarr.map((item, index) => {
				dpArr.push(item.DPMID)
			})
			let {
				code,
				data,
				message
			} = await DespatchDetailByDPMIDs({
				dpmiDs: dpArr,
			})
			if (code == 0) {
				this.dialogVisibleoutboundorder = false
				this.dialogVisibleoutboundorderedit = true
				setTimeout(() => {
					console.log(this.$refs.outupdate);
					try {

						this.$refs.outupdate[3].modelvalue = data.VouCodes
						this.$refs.outupdate[8].modelvalue = data.ReturnFlag == 0 ? "蓝票" : "红票"
						this.$refs.outupdate[9].modelvalue = data.Hospital ? data.Hospital : '';
						this.$refs.outupdate[10].modelvalue = data.TerminalHPName
						this.TerminalHPID = data.TerminalHPID
						this.TerminalHPName = data.TerminalHPName
						// if (SellerType == '医院') {
						//   // this.$refs.outupdate[10].disabled = true
						// }
						this.invupdatefromdata[10].disabledHB = true

						if (!data.Hospital) {
							this.invupdatefromdata[9].disabledHB = false;
						} else {
							this.invupdatefromdata[9].options = [{
								key: data.Hospital,
								value: data.CusName
							}]
						}
						console.log('111111=------>', data, data.Hospital, this.invupdatefromdata)
					} catch (error) {
						console.log(error);
					}
					this.showBtn = true
					this.DesData = data
					this.tableDataDespatchupdate = data.data
					if (this.CusTypeFlog == 1) {
						this.invupdatefromdata[8].inputflag = true
					}
					if (this.CusTypeFlog == 2) {
						this.invupdatefromdata[9].inputflag = true
					}
					this.invupdatefromdata[7].disabled = false
					//console.log('=------>', this.$refs.outupdate[3].modelvalue)
					loading.close();
					this.$forceUpdate();
				}, 200)
			} else if (code == 101) {
				this.dialogVisibleoutboundorderedit = false
				this.dialogVisibleoutboundorder = true
				this.$message({
					type: "warning",
					message: message
				})
				loading.close()
				return
			} else if (code == 201) {
				loading.close();
				this.$confirm(message, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.dialogVisibleoutboundorder = false
					this.dialogVisibleoutboundorderedit = true
					setTimeout(() => {
						console.log(this.$refs.outupdate);
						try {
							this.$refs.outupdate[3].modelvalue = data.VouCodes
							this.$refs.outupdate[8].modelvalue = data.ReturnFlag == 0 ? "蓝票" : "红票"
							this.$refs.outupdate[9].modelvalue = data.Hospital ? data.Hospital :
								'';
							this.$refs.outupdate[10].modelvalue = data.TerminalHPName
							this.TerminalHPID = data.TerminalHPID
							this.TerminalHPName = data.TerminalHPName
							// if (SellerType == '医院') {
							//   // this.$refs.outupdate[10].disabled = true
							// }
							this.invupdatefromdata[10].disabledHB = true

							if (!data.Hospital) {
								this.invupdatefromdata[9].disabledHB = false;
							} else {
								this.invupdatefromdata[9].options = [{
									key: data.Hospital,
									value: data.CusName
								}]
							}
							//console.log('111=------>', this.$refs.outupdate[3])
						} catch (error) {
							console.log(error);
						}
						this.showBtn = true
						this.DesData = data
						this.tableDataDespatchupdate = data.data
						if (this.CusTypeFlog == 1) {
							this.invupdatefromdata[8].inputflag = true
						}
						if (this.CusTypeFlog == 2) {
							this.invupdatefromdata[9].inputflag = true
						}
						this.invupdatefromdata[7].disabled = false
						//console.log('=------>', this.$refs.outupdate[3].modelvalue)
						loading.close();
						this.$forceUpdate();
					}, 200)
				}).catch(() => { });
			} else {
				this.dialogVisibleoutboundorderedit = false
				this.dialogVisibleoutboundorder = true
				loading.close();
			}
		},
		async DespatchDetailByDPMIDs2(e) {
			const loading = this.$loading({
				lock: true,
				text: '正在加载列表...',
				spinner: 'el-icon-loading',
				background: 'rgba(255,255,255,0.3)'
			});
			let dpArr = []
			this.dpmiDsarr.map((item, index) => {
				dpArr.push(item.SBMID)
			})
			let {
				code,
				data,
				message
			} = await GetSaleBillDetailBySBMIDs({
				SBMIDs: dpArr,
				RedType: e,
			})
			if (code == 0) {
				try {
					this.$refs.outupdate[3].modelvalue = data.VouCodes
					this.$refs.outupdate[8].modelvalue = data.ReturnFlag == 0 ? "蓝票" : "红票"
					this.$refs.outupdate[9].modelvalue = data.Hospital ? data.Hospital : '';
					this.$refs.outupdate[10].modelvalue = data.TerminalHPName
					this.TerminalHPID = data.TerminalHPID
					this.TerminalHPName = data.TerminalHPName
					// if (SellerType == '医院') {
					//   // this.$refs.outupdate[10].disabled = true
					// }

					if (!data.Hospital) {
						this.invupdatefromdata[9].disabledHB = false;
					} else {
						this.invupdatefromdata[9].options = [{
							key: data.Hospital,
							value: data.CusName
						}]
					}

					this.$refs.outupdate[11].modelvalue = e;
					this.invupdatefromdata[11].options = [{
						value: this.salesType[e],
						key: e
					}]
					this.invupdatefromdata[11].disabledHB = true
					this.invupdatefromdata[10].disabledHB = true
					this.disabledQun = e === 12 || e === 13 ? true : false;
					this.disabledZhe = e === 12 ? true : false;
					this.showBtn = e === 13 ? false : true;
					if (e === 13) {
						this.$refs.outupdate[0].modelvalue = data.InvoiceNo
						this.$refs.outupdate[1].modelvalue = data.SBDate
						this.$refs.outupdate[2].modelvalue = data.CheckWay
						this.$refs.outupdate[4].modelvalue = data.VerifyCode
						this.$refs.outupdate[5].modelvalue = data.SBCode
					}
					//this.invupdatefromdata[7].minleft = -99999
				} catch (error) { }
				this.DesData = data
				this.tableDataDespatchupdate = data.data.map((item, index) => {
					item.SBDID = index;
					return item;
				})
				if (this.CusTypeFlog == 1) {
					this.invupdatefromdata[8].inputflag = true
				}
				if (this.CusTypeFlog == 2) {
					this.invupdatefromdata[9].inputflag = true
				}
				this.invupdatefromdata[7].disabled = false
				this.dialogVisibleoutboundorder = false
				this.dialogVisibleoutboundorder2 = false
				loading.close();
			} else if (code == 101) {
				this.dialogVisibleoutboundorderedit = false
				this.dialogVisibleoutboundorder2 = true
				this.$message({
					type: "warning",
					message: message
				})
				loading.close()
				return
			} else {
				this.dialogVisibleoutboundorderedit = false
				this.dialogVisibleoutboundorder = true
				loading.close();
			}
		},
		handleSelectionChangeEdit(val) {
			this.tableDelArr = val
			this.dpmiDsarr = val
			// let str = ""
			// val.map((item, index) => {
			//   str += item.VouCode + ","
			// })
			// this.$refs.outadd[10].modelvalue = str
		},
		handleSelectionChangeAdd(val) {
			this.dpmiDsarr = val
		},
		// 发票导入
		InvoiceImport(file) {
			this.SaleBillImport(file)
		},
		// 下载模板
		InvoiceDowload() {
			this.SaleBillDownloadTemplet()
		},
		// 上传照片(多选)
		async UploadPhotos(file) {
			const loading = this.$loading({
				lock: true,
				text: '正在上传...',
				spinner: 'el-icon-loading',
				background: 'rgba(255,255,255,0.3)'
			});
			let formdata = new FormData()
			for (var i = 0; i < file.length; i++) {
				formdata.append("files", file[i]);
			}
			let {
				data,
				code,
				message
			} = await SaleBillUploadInvoicePic(formdata)
			if (code == 0) {
				this.$message({
					type: 'success',
					message: message
				});
				loading.close();
			} else if (code == 101) {
				this.$message({
					type: 'warning',
					message: message
				});
				loading.close();
			} else {
				this.dialogVisiblesqsjg = true
				this.tableDataqsjg = data
				this.title = "上传结果"
				this.$message({
					type: 'error',
					message: message
				});
				loading.close();
			}
			this.$parent.saleBillList()
			this.addupdateType = 3
		},
		// 上传销货清单
		async UploadSaleslist(file) {
			if (this.rowboo != true) {
				this.$message({
					type: 'error',
					message: '请选择要操作的数据！'
				});
				return
			}
			if (this.rowboo == true) {
				let formdata = new FormData()
				for (var i = 0; i < file.length; i++) {
					formdata.append("files", file[i]);
				}
				console.log(formdata.get('files'), 'file');
				const loading = this.$loading({
					lock: true,
					text: '正在上传...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let {
					data,
					code,
					message
				} = await SaleBillUploadSalesInvListPic(formdata, this.sbmid)
				if (code == 0) {
					this.$message({
						type: 'success',
						message: message
					});
					loading.close();
					return
				} else if (code == 101) {
					this.$message({
						type: 'warning',
						message: message
					});
					loading.close();
					return
				} else {
					this.dialogVisiblesdrjg = true
					this.tableDatadrjg = data
					this.title = "导入结果"
					this.$message({
						type: 'error',
						message: message
					});
					loading.close();
				}
				return
			}

		},

		// 修改上传照片(销货清单)
		async SaleBillUploadSalesInvListByEdit(file) {
			let formdata = new FormData()
			for (var i = 0; i < file.length; i++) {
				formdata.append("files", file[i]);
			}
			const loading = this.$loading({
				lock: true,
				text: '正在上传...',
				spinner: 'el-icon-loading',
				background: 'rgba(255,255,255,0.3)'
			});
			let {
				data,
				code,
				message
			} = await SaleBillUploadSalesInvListByEdit(formdata, this.sbmid)
			if (code == 0) {
				this.$message({
					type: 'success',
					message: message
				});
				loading.close();
				this.imagePath = data
				return
			} else if (code == 101) {
				this.$message({
					type: 'warning',
					message: message
				});
				loading.close();
				return
			} else {
				this.dialogVisiblesdrjg = true
				this.tableDatadrjg = data
				this.title = "导入结果"
				this.$message({
					type: 'error',
					message: message
				});
				loading.close();
			}
		},
		UploadTopEdit(file) {
			this.SaleBillUploadSalesInvListByEdit(file)
		},
		// 打包下载发票照片 （后缀，rar）
		async SaleBillBatchDownloadInvoicePic(file) {
			const loading = this.$loading({
				lock: true,
				text: '正在上传...',
				spinner: 'el-icon-loading',
				background: 'rgba(255,255,255,0.3)'
			});
			let formdata = new FormData()
			formdata.append("file", file);
			let res = await SaleBillBatchDownloadInvoicePic(formdata)
			if (res.code) {
				if (res.code == 101) {
					this.$message.warning(res.message)
				}
			} else {
				let date = new Date()
				let str = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}-${date.getTime()}`
				utils.downloadFile(res, `发票图片${str}`, "rar", "application/zip")
			}
			console.log(res);
			loading.close()
		},
		DownloadInvoicePic(file) {
			this.SaleBillBatchDownloadInvoicePic(file);
		},
		// 点击行
		onRowClick(val) {
			this.rowboo = true
			this.sbmid = val.SBMID
			this.InvoiceCheckeds = val.InvoiceChecked
			//console.log(val, 'valsss');
			if (val.Status == 1) {
				this.editops = true
				//console.log( this.editops,' this.editops');
			}
			if (val.Status == 0) {
				this.editops = false
				//console.log( this.editops,' this.editops');
			}
			if (val.InvoiceChecked == -1) {
				this.InvoiceChecked = -1
				// this.editops = false
			}
			if (val.InvoiceChecked == 0) {
				this.InvoiceChecked = 0
				// this.editops = false
			}
			if (val.InvoiceChecked == 1) {
				this.InvoiceChecked = 1
				// this.editops = true
			}
			if (val.InvoiceChecked == 2) {
				this.InvoiceChecked = 2
				// this.editops = true
			}
			this.$emit("onRowClick", val)
		},
		canceloutboundorderedit() {
			this.dialogVisibleoutboundorderedit = false
		},
		dialogOKcanceloutboundorderedit() {

			this.dialogVisibleoutboundorderedit = false
		},
		canceloutboundorderedit1() {
			this.dialogVisibleoutboundorderedit = false
		},
		dialogOKcanceloutboundorderedit1() {

			this.dialogVisibleoutboundorderedit = false
		},
		invSel() {
			this.invTitle = "新增发票"
			//console.log(this.invTitle);

			this.DespatchDetailByDPMIDs()
			this.HelperCheckWay()

		},
		invSel2(e) {
			this.invTitle = "新增发票"
			//console.log(this.invTitle);
			this.dialogVisibleoutboundorderedit = true
			this.DespatchDetailByDPMIDs2(e)
			this.HelperCheckWay()

		},
		/** 
		 * 如果当前登录的是一级经销商
		 * 下拉框就是二级经销商
		 * */

		async CustomerList(query) {
			this.loading = true
			let {
				data,
				code
			} = await CustomerList({
				cusName: query
			})
			if (code == 0) {
				this.invaddfromdata[4].options = []
				data.data.map((item, index) => {
					let obj = {
						key: item.CusCode,
						value: item.CusName
					}
					this.invaddfromdata[4].options.push(obj)
				})
				this.loading = false
			}
		},
		/**
		 * 如果当前登录的是二级经销商
		 * 下拉框就是医院
		 */
		async HospitalList(query, parTow, type) {
			this.loading = true
			let {
				data,
				code,
				message
			} = await HospitalList({
				hpName: query,
				[parTow.key]: parTow.value
			})
			if (code == 0) {
				if (type == 'HosType') {
					this.invupdatefromdata[10].options = []
					data.data.map((item, index) => {
						let obj = {
							key: item.TerminalHPName,
							value: item.TerminalHPID
						}
						this.invupdatefromdata[10].options.push(obj)
					})
					this.loading = false
				}
				if (type == 'HosList') {
					this.invaddfromdata[4].options = []
					data.data.map((item, index) => {
						let obj = {
							key: item.HPID,
							value: item.HPName
						}
						this.invaddfromdata[4].options.push(obj)
					})
					this.loading = false
				}
				if (type == 'TerminalHospital') {
					this.invTerminalHospitalfromdata[0].options = []
					data.data.map((item, index) => {
						let obj = {
							key: item.HPID,
							value: item.HPName
						}
						this.invTerminalHospitalfromdata[0].options.push(obj)
					})
					this.loading = false
				}

			} else {
				this.$message.warning(message)
			}
		},
		remoteMethodtows(query) {
			if (this.CusTypeFlog == 1) {
				this.CustomerList(query)
			} else if (this.CusTypeFlog == 2) {
				this.HospitalList(query, 'HosList')
			}
		},
		// 是否唯一码
		async inventoryClassInfo(invClass) {
			let {
				code,
				data
			} = await InventoryClassInfo({
				invClass: invClass
			})
			if (code == 0) {
				if (data.IsBarCodeControl == 1) {
					let arr = [{
						title: '明细'
					},
					{
						title: '唯一码'
					}
					]
					this.state = arr

				} else if (data.IsBarCodeControl == 0) {
					let arr = [{
						title: '明细'
					}]
					this.state = arr
				}
			}
		},
		invClass(e) {
			this.inventoryClassInfo(e.modelvalue)
		},
		// 产品线下拉
		async inventoryClassList() {
			let {
				code,
				data
			} = await InventoryClassList({

			})
			if (code == 0) {
				this.invaddfromdata[1].options = []
				this.outformdata[3].options = []
				this.selectformdata[9].options = []
				data.data.map((item, index) => {
					let obj = {
						key: item.InvClass,
						value: item.InvClassName
					}
					this.invaddfromdata[1].options.push(obj)
					this.outformdata[3].options.push(obj)
					this.selectformdata[9].options.push(obj)
				})
			}
		},
		// 单据类型下拉
		async helperDPVoucherType() {
			let {
				code,
				data
			} = await HelperDPVoucherType({})
			if (code == 0) {
				this.outformdata[5].options = []
				data.map((item, index) => {
					let obj = {
						key: item.Value,
						value: item.Text
					}
					this.outformdata[5].options.push(obj)
				})

			}

		},
		// 单据类型下拉aSNVoucherType
		async aSNVoucherType() {
			let {
				code,
				data
			} = await ASNVoucherType({})
			if (code == 0) {
				this.invaddfromdata[6].options = []
				data.map((item, index) => {
					let obj = {
						key: item.Value,
						value: item.Text
					}
					this.invaddfromdata[6].options.push(obj)
				})
			}
		},
		// 判断修改是否���用
		async CusType() {
			let {
				data,
				code
			} = await CusType({})
			if (code == 0) {
				// this.CusTypeState = data.CusType
				if (data.CusType == "") {
					this.CusTypeFlog = 0
					this.editops = false //测试中
				} else if (data.CusType == "平台") {
					this.CusTypeFlog = 1
				} else if (data.CusType == "经销商") {
					this.CusTypeFlog = 2
				}
			}
		},
		SaleBillExport() {
			this.$emit("SaleBillExport")
		},
		canceldrjg() {
			this.dialogVisiblesqsjg = false
		},
		dialogOKdrjg() {
			if (this.addupdateType == 2) {
				this.SaleBillAdd()
			} else if (this.addupdateType == 1) {
				this.SaleBillEdit()
			} else if (this.addupdateType == 3) {
				this.dialogVisiblesqsjg = false
			}
			this.dialogVisiblesqsjg = false

		},
		invAdd() {
			this.inventoryClassList()
			this.helperDPVoucherType()
			// this.aSNVoucherType()
			this.despatchList()

			this.addupdateType = 2

		},
		canceloutboundorder() {
			this.dialogVisibleoutboundorder = false
		},
		dialogOKcanceloutboundorder() {

		},
		adduser() {
			this.dialogVisibles = true
		},
		cancel() {
			this.dialogVisibles = false
		},
		dialogOK() {
			this.dialogVisibles = false
		},
		// 发票照片标注
		async SaleBillDoMultiInvoiceCheckedChange() {
			let arr = []
			this.sbmidarr.map((item, index) => {
				arr.push(item.SBMID)
			})
			let {
				code,
				data,
				message
			} = await SaleBillDoMultiInvoiceCheckedChange({
				sbmiDs: arr,
				lstImageNames: this.imagePath,
				Remark: this.InvoiceRemark,
				CheckLabelStatus: this.InvoiceValue == "驳回" ? 0 : this.InvoiceValue == "通过" ? 1 : 4,
			})
			if (code == 0) {
				this.$message({
					type: "success",
					message: message
				})
				this.dialogVisiblesinvoicephoto = false
				this.rowboo = false
				this.$refs.refTableCenter.$refs.fileTableSelect.clearSelection()
				this.sbmidarr = []
				this.$parent.saleBillList()
			} else if (code == 1) {
				this.$message({
					type: "warning",
					message: message
				})
				this.dialogVisiblesqsjg = true
				this.title = '发票标注结果'
				this.tableDataqsjg = data
				this.$refs.refTableCenter.$refs.fileTableSelect.clearSelection()
				this.sbmidarr = []
				this.$parent.saleBillList()
			} else {
				this.$message({
					type: "error",
					message: message
				})
			}
		},
		UploadSalesphoto(file) {
			this.SaleBillUploadSalesInvListByEdit(file)
		},
		invoicephoto() {
			if (this.sbmidarr.length > 0) {
				this.dialogVisiblesinvoicephoto = true
				return
			}
			this.$message({
				type: "error",
				message: "请选择要操作的数据(多选)！"
			})
		},
		cancelinvoicephoto() {
			this.dialogVisiblesinvoicephoto = false
		},
		dialogOKinvoicephoto() {
			this.SaleBillDoMultiInvoiceCheckedChange()

		},
		shen() {
			if (this.sbmidarr.length > 0) {
				this.dialogVisibleshen = true
				return
			}
			this.$message({
				type: 'error',
				message: '请选择要审核的数据！'
			});

		},
		cancelshen() {
			this.dialogVisibleshen = false
		},
		dialogOKshen() {
			this.saleBillVerify()
			this.dialogVisibleshen = false
		},
		qshen() {
			if (this.sbmidarr.length > 0) {
				this.dialogVisibleqshen = true
				return
			}
			this.$message({
				type: 'error',
				message: '请选择要弃审的数据！'
			});

		},
		dialogOKqshen() {
			this.saleBillUnVerify()
			this.dialogVisibleqshen = false
		},
		cancelqshen() {
			this.dialogVisibleqshen = false
		},
		del() {
			if (this.sbmidarr.length > 0) {
				this.dialogVisibleqdel = true
				return
			}
			this.$message({
				type: 'error',
				message: '请选择要删除的数据！'
			});
		},
		update() {
			if (this.sbmidarr.length === 1) {
				this.dialogVisibleoutboundorderedit = true
				this.SaleBillInfo()
				this.HelperCheckWay()
				this.addupdateType = 1
				this.invTitle = "修改发票"
				return
			}
			this.$message({
				type: 'error',
				message: '请选择要修改的数据！'
			});
		},
		dialogOKdel() {
			this.saleBillDelete()
			this.dialogVisibleqdel = false
		},
		canceldel() {
			this.dialogVisibleqdel = false
		},
		downs() {

		},
		handleCurrentChange(pageindex) {
			this.$emit('handleCurrentChange', pageindex)
		},
		handleSizeChange(paegSzie) {
			this.$emit('handleSizeChange', paegSzie)
		},
		handleSelectionChange(val) {
			this.sbmidarr = val
			if (val.length === 1) {
				this.rowboo = true
				this.sbmid = val[0].SBMID
				return
			}
			this.rowboo = false
			if (val.length === 0) {
				this.sbmid = ''
			}
		},
		Quantity522(obj) {
			console.log(this.editRowTableData);
			let num = obj.e.target.value;
			if (this.$refs.outupdate[8].modelvalue === '蓝票') {
				if (Number(num) <= 0 || Number(num) === NaN) {
					this.editRowTableData.Quantity = 1;
					return
				}
			} else if (this.$refs.outupdate[11].modelvalue === 11) {
				if (Number(num) >= 0 || Number(num) === NaN) {
					this.editRowTableData.Quantity = -1;
					return
				}
			}
		},
		GuidanceVideo() {
			this.dialogVisibGuidanceVideo = true
		},
		cancelGuidanceVideo() {
			this.dialogVisibGuidanceVideo = false
		},
		dialogOKGuidanceVideo() {
			this.dialogVisibGuidanceVideo = false
		},
		hide() {
			this.showorhide = false
		},
		showclick() {
			this.showorhide = true
		},
		select() {

		},
		async getSaleBillList() {
			const loading = this.$loading({
				lock: true,
				text: '正在加载列表...',
				spinner: 'el-icon-loading',
				background: 'rgba(255,255,255,0.3)'
			});

			let {
				data,
				code
			} = await SaleBillList({
				ReferToBack: '1'
			})
			if (code == 0) {
				this.totals = data.Count
				this.tableDataDespatch = data.data

				this.dialogVisibleoutboundorder = true
			} else {
				this.$message.warning(message)
			}
			loading.close();
		},
		handleDrop(e) {
			this.inventoryClassList()
			this.helperDPVoucherType()
			this.addupdateType = 2
			// this.aSNVoucherType()
			if (e === 'a') {
				this.despatchList()
			} else {
				//this.getSaleBillList()
				this.saleBillList();
			}
		},
		handSelect() {
			for (let item of this.selectformdata) {
				this.selectformdatalist.push(item.inputdata)
			}
			this.pageindex = 1
			// 页码重置为1
			try {
				this.selectformparams.invoiceNo = this.$refs.invselect[0].modelvalue
				this.selectformparams.buyerName = this.$refs.invselect[1].modelvalue
				this.selectformparams.total1 = this.$refs.invselect[2].modelvalueleft
				this.selectformparams.total2 = this.$refs.invselect[2].modelvalueright
				this.selectformparams.createTime1 = this.$refs.invselect[3].startTime
				this.selectformparams.createTime2 = this.$refs.invselect[3].endTime
				this.selectformparams.sbDate1 = this.$refs.invselect[4].startTime
				this.selectformparams.sbDate2 = this.$refs.invselect[4].endTime
				this.selectformparams.inventory = this.$refs.invselect[5].modelvalue
				this.selectformparams.verifyTime1 = this.$refs.invselect[6].startTime
				this.selectformparams.verifyTime2 = this.$refs.invselect[6].endTime
				this.selectformparams.vouCode = this.$refs.invselect[7].modelvalue
				this.selectformparams.returnFlag = this.$refs.invselect[8].modelvalue
				this.selectformparams.invClass = this.$refs.invselect[9].modelvalue
				this.selectformparams.TerminalHPName = this.$refs.invselect[10].modelvalue
				this.saleBillList()
			} catch (error) {
				this.saleBillList()
			}
		},
		handReset() {
			for (let index in this.$refs.invselect) {
				if (index == 3 || index == 4 || index == 6) {
					this.$refs.invselect[index].startTime = ''
					this.$refs.invselect[index].endTime = ''
				} else if (index == 2) {
					this.$refs.invselect[index].modelvalueleft = undefined
					this.$refs.invselect[index].modelvalueright = undefined
				} else {
					this.$refs.invselect[index].modelvalue = ''
				}
			}
			this.selectformparams = {};
		},
		async saleBillList() {
			const loading = this.$loading({
				lock: true,
				text: '正在加载列表...',
				spinner: 'el-icon-loading',
				background: 'rgba(255,255,255,0.3)'
			});
			// setTimeout(() => {
			// 	this.$refs.invtable.$refs.refTableCenter.$refs.fileTableSelect.clearSelection()
			// }, 100)
			let {
				data,
				code
			} = await SaleBillList({
				invoiceNo: this.selectformparams.invoiceNo,
				invoiceChecked: this.selectformparams.invoiceChecked,
				sbDate1: this.selectformparams.sbDate1,
				sbDate2: this.selectformparams.sbDate2,
				salerName: this.selectformparams.salerName,
				total1: this.selectformparams.total1,
				total2: this.selectformparams.total2,
				createTime1: this.selectformparams.createTime1,
				createTime2: this.selectformparams.createTime2,
				buyerName: this.selectformparams.buyerName,
				inventory: this.selectformparams.inventory,
				verifyTime1: this.selectformparams.verifyTime1,
				verifyTime2: this.selectformparams.verifyTime2,
				vouCode: this.selectformparams.vouCode,
				returnFlag: this.selectformparams.returnFlag,
				invClass: this.selectformparams.invClass,
				TerminalHPName: this.selectformparams.TerminalHPName,
				pageSize: this.pageSize2,
				pageIndex: this.pageindex2,
				ReferToBack: 1
			})
			if (code == 0) {
				this.dialogVisibleoutboundorder2 = true;
				this.total2 = data.Count
				this.tableDataDespatch2 = data.data
			} else {
				this.$message.warning(message)
			}
			loading.close();
		},
		handleCurrentChanges2(pageindex) {
			this.pageindex2 = pageindex
			this.saleBillList()
		},
		handleSizeChanges2(paegSzie) {
			this.pageSize2 = paegSzie
			this.saleBillList()
		},
		onRowClickSel(val) {
			this.sbmid = val.SBMID
			this.SaleBillDetail();
			this.SaleBillDetailUnique();
		},
		// 明细
		async SaleBillDetail() {
			let {
				data,
				code
			} = await SaleBillDetail({
				sbmid: this.sbmid
			})
			if (code == 0) {
				this.tableDataDetail = data
				//this.tableDataMD = data
			}
		},
		// 唯一码
		async SaleBillDetailUnique() {
			let {
				data,
				code,
				message
			} = await SaleBillDetailUnique({
				sbmid: this.sbmid
			})
			if (code == 0) {
				this.tableDataUnique = data
				//this.tableDataMD = data
			} else if (code == 101) {
				this.$message({
					type: 'warning',
					message: message
				});
			} else {
				this.$message({
					type: 'error',
					message: message
				});
			}
		}
	},
	watch: {
		dialogVisibleoutboundorderedit: {
			handler(newVal, oldVal) {
				if (newVal == false) {
					this.Fourelementsfalg = false
					this.sbpdidFalg = false

					this.$refs.outupdate.map((item, index) => {
						item.modelvalue = ""
					})
					this.invupdatefromdata[7].minleft = undefined;
				}
			},
			deep: true
		},
		dialogVisibleoutboundorder: {
			handler(newVal, oldVal) {
				if (newVal == false) {
					this.$refs.Table511.$refs.fileTableSelect.clearSelection()

				}
			},
			deep: true
		},
		dialogVisiblesinvoicephoto: {
			handler(newVal, oldVal) {
				if (newVal == false) {
					this.InvoiceValue = ''
					this.InvoiceRemark = ''
					this.imagePath = ''
				}
			}
		},

		dialogVisibGuidanceVideo: {
			handler(newVal, oldVal) {
				if (newVal == false) {
					// 弹窗关闭暂定视频
					this.$refs.invoicesVideo.$refs.videoPlayer.pause()
				}
			},
			deep: true
		},
		dialogVisibTerminalHospital: {
			handler(newVal, oldVal) {
				if (newVal == false) {
					// 弹窗�����闭暂定视频
					this.$refs.outTerminalHospital[0].modelvalue = ''
					this.$refs.refTableCenter.$refs.fileTableSelect.clearSelection()
				}
			},
			deep: true
		},
		dialogVisibleoutboundorder2: {
			handler(newVal, oldVal) {
				if (newVal == false) {
					this.dpmiDsarr = [];
					this.$refs.Table512.$refs.fileTableSelect.clearSelection()
				}
			},
			deep: true
		}
	}
}
</script>

<style lang="less" scoped>
.ativte {
	border: 1px solid red;
	color: #e71d43;
	background-color: #fce8ec;
	transition: 0.2s linear;
}

.incenters {
	height: 100%;

	.pagination {
		display: flex;
		justify-content: center;
		align-items: center;
		/*margin-top: 16px;*/
		/*padding-bottom: 16px;*/
	}

	// div {
	//   margin-left: 8px;
	//   margin-right: 8px;
	//   margin-top: 5px;
	//   margin-bottom: 5px;

	// }
	.from {
		width: 100%;
	}

	.signingroles {
		height: 500px;
		width: 100%;
		// display: flex;
		// justify-content: space-between;
		// align-items: center;
		// border: 1px solid red;

		.left {
			height: 240px;
			width: 470px;
			border: 1px solid #e6e6e6;
		}

		.right {
			height: 240px;
			width: 470px;
			border: 1px solid #e6e6e6;
			// pointer-events: none;
		}
	}
}

.right-s {
	position: absolute;
	z-index: 99;
	opacity: 0.5;
	right: 21px;
	width: 470px;
	height: 240px;
	background-color: #ffffff;
	cursor: no-drop;
}

.topstate {
	width: 100px;
	height: 32px;
	font-size: 14px;
	border: 1px solid #e6e6e6;
	line-height: 32px;
	text-align: center;
	cursor: pointer;
	display: inline-block;
	margin-left: 10px;
	margin-bottom: 20px;
}

.dwonleft {
	width: 170px;
	height: 48px;
	position: absolute;
	background-color: #ffffff;
	z-index: 99;
	right: 350px;
	top: 322px;
	text-align: center;
	line-height: 48px;
	color: #333333;
	box-shadow: 0px 9px 28px 8px rgba(0, 0, 0, 0.05),
		0px 6px 16px 0px rgba(0, 0, 0, 0.08), 0px 3px 6px -4px rgba(0, 0, 0, 0.12);
	border-radius: 2px;
	font-size: 14px;
	cursor: pointer;
}

.dwonleft:hover {
	background-color: #f0f0f0;
}

.elselect {
	/deep/.el-input--suffix .el-input__inner {
		padding-right: 30px;
		height: 40px;
		width: 613px;
		border-radius: 2px;
	}
}

.inputtop {
	width: 980px !important;
	height: 150px;
	box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
	background-color: #ffffff;
	padding-top: 15px;
	padding-bottom: 70px;
	margin-left: -10px;
	transition: all 0.3s;
	overflow: hidden;
	position: relative;
}

.inputtops {
	width: 980px !important;
	height: 0px;
	box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
	background-color: #ffffff;
	padding-top: 9px;
	padding-bottom: 64px;
	margin-left: -10px;
	overflow: hidden;
	position: relative;
	transition: all 0.3s;
}

.Btngroup {
	display: inline-block;
	float: right;
	margin-right: 0px;
	width: 267px;
	height: 50px;
	background-color: #ffffff;
	position: relative;
	bottom: 140px;
}

.Btngroups {
	display: inline-block;
	float: right;
	margin-top: 5px;
	margin-right: 0px;
}

.drop-down-link {
	margin: 10px;
	width: 100%;
	height: 32px;
	line-height: 32px;
	color: rgb(0, 0, 0);
	font-size: 14px;
	//background-color: rgb(249, 250, 252);
	border: 1px solid #e6e6e6;
	display: flex;
	justify-content: center;
	align-items: center;
	cursor: pointer;
	//
}

/deep/.el-dropdown-menu__item:focus,
.el-dropdown-menu__item:not(.is-disabled):hover {
	background-color: rgb(255 235 235);
	color: #606266;
}
</style>
